// Local exit is unconditional; remote revocation must be explicitly confirmed.
export async function logoutSession({ sessionId, clearLocal, warn, navigate, fetchImpl = fetch }) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    let confirmed = false;
    try {
        const pending = fetchImpl('/api/auth/logout', {
            method: 'POST', credentials: 'same-origin', signal: controller.signal,
            headers: { 'Content-Type': 'application/json', ...(sessionId ? { 'x-session-id': sessionId } : {}) }, body: JSON.stringify({ sessionId }),
        });
        clearLocal();
        const response = await pending;
        confirmed = response.ok && (await response.json()).ok === true;
    } catch {
        clearLocal();
    } finally {
        clearTimeout(timeout);
    }
    if (!confirmed) warn('Sess?o local encerrada. N?o foi poss?vel confirmar a revoga??o no servidor. Fa?a novo login e encerre a sess?o quando a conex?o estiver dispon?vel.');
    navigate();
    return { confirmed };
}
